module.exports = __webpack_public_path__ + "img/appointment_tip.8b1ccf33.png";